import React, { useState } from 'react';
import { translate } from '@utils/i18n';
import { Button } from '@ui';
import { TextInput } from '@ui/molecules/inputs/form/TextInput';
import { Modal, ModalHeader, ModalBody, ModalFooter } from '@ui/molecules/Modal';
const namespace = 'features.resolution_status';
function AddStatusModal({ isOpen, onClose, onSubmit, isLoading }) {
    const [statusName, setStatusName] = useState('');
    const [nameError, setNameError] = useState('');
    const handleInputChange = (e) => {
        setStatusName(e.target.value);
        if (e.target.value.trim() !== '') {
            setNameError('');
        }
    };
    const handleSubmit = () => {
        if (statusName.trim() === '') {
            setNameError(translate('status_name_required', { namespace }));
            return;
        }
        onSubmit(statusName.trim());
        setStatusName('');
    };
    const handleCancel = () => {
        setStatusName('');
        setNameError('');
        onClose();
    };
    return (React.createElement(Modal, { isOpen: isOpen, onClose: handleCancel, ariaLabel: translate('add_new_status', { namespace }) },
        React.createElement(ModalHeader, { title: translate('add_new_status', { namespace }), onClose: handleCancel }),
        React.createElement(ModalBody, null,
            React.createElement(TextInput, { id: "newStatusName", name: "newStatusName", value: statusName, onChange: handleInputChange, label: translate('status_name', { namespace }), placeholder: " ", error: nameError, required: true })),
        React.createElement(ModalFooter, null,
            React.createElement(Button, { onClick: handleCancel }, translate('cancel', { namespace: 'features.commons' })),
            React.createElement(Button, { variant: "primary", onClick: handleSubmit, disabled: isLoading }, isLoading
                ? translate('saving', { namespace: 'features.commons' })
                : translate('save', { namespace: 'features.commons' })))));
}
export default AddStatusModal;
